import React, { useContext } from 'react';

/**
 * Some callbacks used in UP Wizard may need to be passed down too many levels,
 * using this context to hold them.
 */

export const UpWizardCallbackContext = React.createContext({});

export const useUpWizardCallbackContext = () => useContext(UpWizardCallbackContext);
